import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "exception-body notfound" }
const _hoisted_2 = { class: "exception-wrapper" }
const _hoisted_3 = { class: "exception-content" }
const _hoisted_4 = { class: "exception-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "404", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('page_not_found')), 1)
      ])
    ])
  ]))
}